import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyS, HeadlineL } from '@sorare/core/src/atoms/typography';
import { Dialog } from '@sorare/core/src/components/dialog';
import { glossary } from '@sorare/core/src/lib/glossary';

const DialogWrapper = styled(Vertical).attrs({ center: true })`
  padding: 0 var(--double-unit) var(--double-unit) 0;
  color: var(--c-nd-700);
  & li {
    list-style-type: disc;
  }
`;

const DialogButton = styled.div`
  padding-left: var(--double-unit);
  width: 100%;
`;

type Props = { open: boolean; onClose: () => void };
export const InfoDialog = ({ open, onClose }: Props) => {
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      title={
        <HeadlineL className="text-center">
          <FormattedMessage {...glossary.howItWorks} />
        </HeadlineL>
      }
      onClose={onClose}
      fullScreen={false}
    >
      <DialogWrapper>
        <BodyS>
          <ul>
            <FormattedMessage
              id="UnlockPro.howItWorksDescription2"
              defaultMessage="<li>Twice a week, jump into free competitions and play for epic rewards.</li><li>Start with Common Cards — perfect for learning the game and sharpening your strategy.</li><li>Go Pro with Limited Cards — and compete for VIP experiences and over $15M in yearly cash prizes. These cards are yours to trade, buy, and sell with other Sorare Managers.</li><li>Think you know fantasy football? Prove it.</li><li>*The average lineup cost for Limited and Rare is determined by the price of cards in the average reward-winning lineup for the current season.</li><li>*Prize pool amounts correspond to the total amount of yearly cash rewards in each scarcity.</li>"
              values={{
                li: chunks => <li>{chunks}</li>,
              }}
            />
          </ul>
        </BodyS>
        <DialogButton>
          <Button size="medium" color="quaternary" fullWidth onClick={onClose}>
            <FormattedMessage {...glossary.gotIt} />
          </Button>
        </DialogButton>
      </DialogWrapper>
    </Dialog>
  );
};
